import { Filter } from "@mui/icons-material";
import { Image } from "@mui/icons-material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import { Subtype } from "./subtype";
import MultiPictureUploadEditorPreview from "../../../components/actionModules/subtypes/multiPictureUpload/MultiPictureUploadEditorPreview";
import MultiPictureUploadSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/MultiPictureUploadSubtypeDetails";
import { MultiPictureUploadSubtypeResponse, MultiPictureUploadSubtypeDataModel } from "./multiPictureUploadSubtype";
import MultiPictureUploadSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/MultiPictureUploadSubtypeSummary";

export const MultiPictureUploasSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.multiPictureUpload.name",
    type: Subtype.MultiPictureUploadModuleSubtype,
    icon: <Image />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<Filter />}
        name="actionModules.subtypes.multiPictureUpload.name" />,
    editorPreview: MultiPictureUploadEditorPreview,
    subtypeDataView: (props) => <MultiPictureUploadSubtypeDetails
                subtype={props.subtype as MultiPictureUploadSubtypeResponse}
                subtypeData={props.subtypeData as MultiPictureUploadSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <MultiPictureUploadSubtypeSummary
                subtype={props.subtype as MultiPictureUploadSubtypeResponse}
                subtypeData={props.subtypeData as MultiPictureUploadSubtypeDataModel} />,
    editableProperties: [
        {
            name: "pictureDescription",
            displayName: "actionModules.subtypes.multiPictureUpload.pictureDescription",
            propertyType: PropertyTypes.text
        },
        {
            name: "exampleImageUrl",
            displayName: "actionModules.subtypes.multiPictureUpload.exampleImageUrl",
            propertyType: PropertyTypes.text
        },
        {
            name: "minimumRequiredPictures",
            displayName: "actionModules.subtypes.multiPictureUpload.minimumRequiredPictures",
            propertyType: PropertyTypes.integer
        },
        {
            name: "maximumAllowedPictures",
            displayName: "actionModules.subtypes.multiPictureUpload.maximumAllowedPictures",
            propertyType: PropertyTypes.integer
        },
        {
            name: "generateSummaryPdf",
            displayName: "actionModules.subtypes.multiPictureUpload.generateSummaryPdf",
            propertyType: PropertyTypes.boolean
        },
    ]
};
